import { render, staticRenderFns } from "./TutorDashboardSubmitAvailabilitiesModal.vue?vue&type=template&id=89688240&scoped=true&"
import script from "./TutorDashboardSubmitAvailabilitiesModal.vue?vue&type=script&lang=js&"
export * from "./TutorDashboardSubmitAvailabilitiesModal.vue?vue&type=script&lang=js&"
import style0 from "./TutorDashboardSubmitAvailabilitiesModal.vue?vue&type=style&index=0&id=89688240&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89688240",
  null
  
)

export default component.exports